import { chunk } from "lodash";
import { useMemo, useState } from "react";
import styles from "./index.module.less";
import ResourceCard, { IHomeResourceCard } from "./ResourceCard";

export interface MaterialElement {
  id: number;
  title: string;
  material: IHomeResourceCard;
  priority: number;
  start_time: Date | null;
  end_time: Date | null;
  status: number;
  created_at: Date;
  test_user_ids: null;
  sort_disturb_setting: null;
}

/**
 * 首页瀑布流
 * @param param0
 * @returns
 */
export default function Feed({
  list,
  name,
  lazyImg = false,
}: {
  list: MaterialElement[];
  name: string;
  lazyImg?: boolean;
}) {
  const chunkArr = useMemo(() => {
    return chunk(list, 2);
  }, [list]);

  const [colNum, setColNum] = useState(8);

  return (
    <div className={styles.feed}>
      {chunkArr.map((items, index) =>
        index < colNum ? (
          <div className={styles.col} key={index}>
            {items.map((item, ii) => {
              return (
                <ResourceCard
                  key={ii}
                  {...item.material}
                  contentSource={name}
                  resource={item}
                  lazyImg={lazyImg}
                />
              );
            })}
          </div>
        ) : null
      )}
    </div>
  );
}
